import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-355" data-mp="3vklmc3pig2di">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 z-50 backdrop-blur-sm" data-id="element-356" data-mp="3vj0tqjmratia" />
          <motion.div initial={{
        opacity: 0,
        y: '100%',
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: '100%',
        scale: 0.9
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed inset-x-4 bottom-4 top-24 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl bg-charcoal-light border border-charcoal-light rounded-lg shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-357" data-mp="2f8oq2fkqq4dg">
            <div className="flex items-center justify-between p-6 border-b border-charcoal" data-id="element-358" data-mp="1uewktddu7pny">
              <h2 className="text-xl font-heading font-bold text-sand" data-id="element-359" data-mp="1gfeswp58vwad">
                {title}
              </h2>
              <button onClick={onClose} className="text-offwhite-dim hover:text-sand transition-colors p-2" aria-label="Close modal" data-id="element-360" data-mp="1kffgazabnhtk">
                <XIcon className="w-6 h-6" data-id="element-361" data-mp="3iab5as6sr1qw" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1 text-offwhite-dim text-sm leading-relaxed space-y-4" data-id="element-362" data-mp="3ddufzunv2hc8">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}